export const speedRules = [
  v => (v !== '') || 'Number is required',
  v => (v >= 0 && v <= 100) || '0 <= v <= 100'
]

export const timeRules = [
  v => (v !== '') || 'Number is required',
  v => (v >= 0) || 'Positive number is required'
]

export const degreesRules = [
  v => (v !== '') || 'Number is required',
  v => (v >= -90 && v <= 90) || '-90 <= v <= 90'
]

export const degreesRules359 = [
  v => (v !== '') || 'Number is required',
  v => (v >= -359 && v <= 359) || '-359 <= v <= 359'
]

export const percloseRules = [
  v => (v !== '') || 'Number is required',
  v => (v >= 0 && v <= 1) || '0 <= v <= 1'
]
